export enum ModalTypes {
  Success = 1,
  Info = 2,
  Warning = 3,
  Alert = 4
}
